import React, { useRef, useState } from "react";
import { useAutosizeTextarea } from "../../../../hooks/useAutosizeTextarea";

interface InputSectionProps {
  value: null | string;
  onChange: (value: string) => void;
  onSubmit: () => void;
}

const InputSection = ({ value, onChange, onSubmit }: InputSectionProps) => {
  // console.log("value",value)
  const [rows, setRows] = useState(1);
  const textareaRef = useRef<HTMLTextAreaElement>(null);

  // auto resize sem mexer na estrutura/markup
  useAutosizeTextarea(textareaRef, value as string);

  const handleKeyDown = (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
    // SHIFT + ENTER → quebra linha
    if (e.key === "Enter" && e.shiftKey) {
      return; // deixa o textarea quebrar linha normalmente
    }
    // ENTER sozinho → envia mensagem
    if (e.key === "Enter") {
      e.preventDefault();
      setRows(1);
      onSubmit();
    }

    if (e.key === "Escape") {
      // ação ao apertar ESC
      e.preventDefault();
      setRows(1);

      const el = textareaRef.current;
      if (!el) return;

      el.value = "";

      // calcula altura de 1 linha
      const style = window.getComputedStyle(el);
      const lineHeight = parseInt(style.lineHeight);

      // libera pra crescer
      el.rows = 1;

      // calcula qtd linhas reais pelo scrollHeight
      const nextRows = Math.floor(el.scrollHeight / lineHeight);

      setRows(nextRows);

      return;
    }

  }

  const handleChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {

    const el = textareaRef.current;
    if (!el) return;

    el.value = e.target.value;

    // calcula altura de 1 linha
    const style = window.getComputedStyle(el);
    const lineHeight = parseInt(style.lineHeight);

    // libera pra crescer
    el.rows = 1;

    // calcula qtd linhas reais pelo scrollHeight
    const nextRows = Math.floor(el.scrollHeight / lineHeight);

    setRows(nextRows);

    onChange(e.target.value);
  };

  return (
    <div className="position-relative">
      <textarea
        ref={textareaRef}
        className="form-control form-control-lg chat-input"
        id="chat-input"
        placeholder="Digite sua mensagem ou / (para respostas rapida)"
        value={value || ""}
        // onChange={(e) => onChange(e.target.value)}
        onChange={handleChange}
        autoComplete="off"
        rows={rows}
        onKeyDown={(e) => handleKeyDown(e)}
        style={{
          resize: "none",
          overflow: "hidden",
          maxHeight: "180px",
        }}
      />

    </div>
  );
};

export default InputSection;
